export const educationData = [
  {
    id: 1,
    year: "Eylül 2021 - Halen 4. Sınıf (2026)",
    degree: "Bilgisayar Mühendisliği",
    institution: "Tarsus Üniversitesi",
    description:
      "Bilgisayar mühendisliği lisans eğitimi, yazılım geliştirme ve algoritma odaklı dersler",
    logo: "img/tarsusuni.png",
    color: "#4f46e5",
  },
  {
    id: 2,
    year: "Ara 2022 - Ekim 2025",
    degree: "Başkan Yardımcısı & Yazılım Geliştirme Takım Lideri",
    institution: "Tarsus Üniversitesi Genç Bilişimciler",
    description:
      "Tarsus Üniversitesi Genç Bilişimciler Öğrenci Topluluğu",
    logo: "img/gbt.png",
    color: "#3b82f6",
  },
];

export const experienceData = [
  {
    id: 1,
    year: "Ocak 2023 - Halen",
    position: "Freelance Software Developer",
    company: "Freelancer",
    description:
      "Freelance olarak çalışmalarım mevcut. Yerel belediyeler ve hizmet sektöründe bulunan firmalar için yaptığım çalışmalar.",
    logo: "img/endlessLogo.png",
    color: "#10b981",
    location: "Remote",
    type: "Freelancer",
    category: "freelancer",
  },
  {
    id: 2,
    year: "Şubat 2025 - Ocak 2026",
    position: "Yazılım Geliştirici",
    company: "Destade Yazılım Teknoloji",
    description:
      "Mobil, Web ve Masaüstü Uyumlu Uygulamalar Geliştirilmesi, Yayınlanması ve Proje Takibi",
    logo: "img/destade.png",
    color: "#f59e0b",
    location: "Hibrit",
    type: "full-time",
    category: "job",
  },
  {
    id: 3,
    year: "Temmuz 2024 - Eylül 2024",
    position: "Stajyer Yazılım Geliştirici",
    company: "T.C Tarsus Belediyesi",
    description:
      "Belediye içerisinde kullanılacak iki adet uygulamanın geliştirilmesi",
    logo: "img/tarsusbel.png",
    color: "#8b5cf6",
    location: "Mersin",
    type: "internship",
    category: "job",
  },
  {
    id: 4,
    year: "Şubat 2024 - Temmuz 2024",
    position: "Junior Mobil Yazılım Geliştirici",
    company: "Insteption B.V",
    description: "Dinamik mobil uygulama geliştirme",
    logo: "img/Insteption.png",
    color: "#ec4899",
    location: "Remote - Hollanda",
    type: "full-time",
    category: "job",
  },
  {
    id: 5,
    year: "Ocak 2022 - Ağustos 2022",
    position: "Junior Yazılım Geliştirici",
    company: "Peliel Software",
    description:
      "Tekbaş grup şirketlerinden olan Peliel Software",
    logo: "img/peliel.png",
    color: "#f97316",
    location: "Ofisten",
    type: "full-time",
    category: "job",
  },
];
